import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { RequestState } from '../shared/models/request-state';
import { SequenceRequest } from './models/request/sequence.request';
import { SequenceResponse } from './models/response/sequence.response';
import { ApiCacheService } from '@shared/services/api-cache.service';

@Injectable({
  providedIn: 'root',
})
export class SequenceService {
  private readonly _sequenceUrl = `${environment.apiUrl}sequence`;

  constructor(private cacheService: ApiCacheService) {}

  /** Standard method for getting sequence data. Uses standard caching strategy. */
  getSequence(
    sequenceRequest: SequenceRequest
  ): Observable<RequestState<SequenceResponse>> {
    const cacheId = this.getCacheId(sequenceRequest);
    const url = `${this._sequenceUrl}/${sequenceRequest.number}/${sequenceRequest.seat}/${sequenceRequest.date}`;

    return this.cacheService.request<SequenceResponse>(cacheId, url);
  }

  refreshSequence(
    sequenceRequest: SequenceRequest
  ): Observable<RequestState<SequenceResponse>> {
    const cacheId = this.getCacheId(sequenceRequest);
    const url = `${this._sequenceUrl}/${sequenceRequest.number}/${sequenceRequest.seat}/${sequenceRequest.date}`;

    return this.cacheService.forceRefreshGet(cacheId, url);
  }

  /** Generate string to indentify request for caching. */
  getCacheId(sequenceRequest: SequenceRequest): string {
    return `${sequenceRequest.number}/${sequenceRequest.date}/${sequenceRequest.seat}`;
  }
}
